
export class Timeline {
  id: number;
  amount?: number;
  author: Author;
  /** type of timeline
   * POT - DON
   */
  category: string;
  created_at: Date;
  name?: string;

  isToday: false;
  pot?: {
    id: number;
    name: string;
  }
}

export class Author {
  id: number;
  email: string;
  firstname: string;
  lastname: string;
  isCompany: boolean;
}
